import { stylesheet } from 'astroturf';
import styled from 'astroturf/react';
import Svg from 'src/components/Svg';

const datePickerField = styled('label')`
  position: relative;
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 15px;

  & + & {
    border-top: 0;
  }

  &.auth {
    border: none;
    flex-direction: column;
  }

  &.rounded {
    border: none;
  }

  &.monthOnly {
    min-width: 174px;
  }

  &.yearOnly{
      button[class*='react-datepicker__navigation--next']{
        right: 2px !important;
      }  
  }

  &.invisible {
    border: 0;

    & > div {
      border-right: 0;
      padding-left: 0;
    }

    & input {
      transition: var(--ph-transition);
      background-color: var(--white);
      border-radius: var(--ph-border-radius-sm);
      border: 1px solid var(--ph-gray-100);

      &:focus {
        box-shadow: var(--ph-box-shadow-focus);
        outline: none;
      }
    }
  }

  &.flash {
    -webkit-animation: fadeinout 2s linear forwards;
    animation: fadeinout 2s linear forwards;

    @-webkit-keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }

    @keyframes fadeinout {
      50% { box-shadow: 0 0 0 2px var(--ph-green-900); }
    }
  }

  &.heightFitContent {
    height: fit-content;
  }
`;

const datePickerFieldLabel = styled('div')`
  font-size: var(--ph-text-sm);
  display: flex;
  justify-content: space-between;
  flex: 0 0 30%;
  line-height: 1.54;
  align-items: center;
  color: var(--ph-gray-500);
  min-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.auth {
    margin-bottom: 8px;
  }
`;

const datePickerFieldWrapper = styled('div')`
  width: 100%;
  height: 100%;
  position: relative;
`;

const datePickerFieldInput = styled('input')`
  flex: 0 0 60%;
  outline: none;
  border: 0;
  font-size: 1.6rem;
  line-height: 1.25;
  color: var(--black);
  background-color: var(--white);
  padding: 0 14px;
  position: relative;

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

  &.error {
    box-shadow: var(--ph-box-shadow-error);
  }

  &.spaced {
    letter-spacing: 6px;
  }

  &.rounded {
    border-radius: var(--ph-border-radius-sm);
    flex: 0 0 100%;
    height: 50px;
    border: var(--light-grey) 1px solid;

    &:focus {
      border: none;
    }
  }

  &.auth {
    flex: auto;
    height: 50px;
    border-radius: var(--ph-border-radius-sm);
    border: solid 1px rgba(var(--ph-gray-500), 0.2);
    background-color: rgba(var(--ph-gray-500), 0.2);
    color: var(--ph-light-blue-500);

    &:focus {
      box-shadow: none;
      border: 1px solid var(--ph-orange-500);
    }

    &.error {
      box-shadow: none;
      border: 1px solid var(--ph-red-500);
    }
  }
`;

const datePickerFieldArea = styled('textarea')`
  flex: 0 0 60%;
  outline: none;
  border: 0;
  font-size: 1.6rem;
  line-height: 1.25;
  min-height: 141px;
  color: var(--black);
  background-color: var(--white);
  padding: 18px 14px;
  position: relative;
  resize: vertical;

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

  &.error {
    box-shadow: var(--ph-box-shadow-error);
  }

  &.spaced {
    letter-spacing: 6px;
  }
`;

const datePickerFieldRequired = styled('span')`
  position: relative;
  top: 2px;
  color: var(--ph-red-500);
`;

const datePickerFieldError = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: absolute;
  top: 0;
  padding-right: 30px;
  font-size: 1.2rem;
  color: var(--ph-red-500);
  box-shadow: 0 0 0 1px var(--ph-red-500);
  border-radius: var(--ph-border-radius-sm);
  pointer-events: none;
`;

const Stylesheets = stylesheet`
  .custom-css {
    .react-datepicker-wrapper {
      width: 100%;
    }
  }
`;

const QuestionTypeIcon = styled(Svg)`
  width: 15px;
  height: 16px;
  vertical-align: middle;
  pointer-events: none;
`;

export default {
  DatePickerField: datePickerField,
  DatePickerFieldLabel: datePickerFieldLabel,
  DatePickerFieldError: datePickerFieldError,
  DatePickerFieldInput: datePickerFieldInput,
  DatePickerFieldRequired: datePickerFieldRequired,
  DatePickerFieldArea: datePickerFieldArea,
  DatePickerFieldWrapper: datePickerFieldWrapper,
  Stylesheets,
  QuestionTypeIcon,
};
